import api, { apiPrefix } from './Api';
import {
  AffiliateUserSummary,
  affiliateUserSummaryFromResponse,
} from '../interfaces/Affiliate/AffiliateUserSummary';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';
import { MyOrder, myOrderFromResponse } from '../interfaces/Order/MyOrder';
import { Pagination, paginationToParams } from '../interfaces/Pagination';

const affiliateApiPrefix = `${apiPrefix}/affiliate`;

export const getSelfAffiliateCode = async (): Promise<string | null> => {
  const response = await api.get(`${affiliateApiPrefix}/self`);

  return response.data?.affiliate_code ?? null;
};

export const getAffiliateOrders = async (
  pagination: Pagination,
): Promise<PaginatedResponse<MyOrder>> => {
  const response = await api.get(`${affiliateApiPrefix}/orders`, {
    params: paginationToParams(pagination),
  });

  return {
    data: (response.data?.data ?? []).map(myOrderFromResponse),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const getAffiliateSummary = async (): Promise<AffiliateUserSummary> => {
  const response = await api.get(`${affiliateApiPrefix}/summary`);

  return affiliateUserSummaryFromResponse(response.data?.data);
};
